import { render, staticRenderFns } from "./PasswordRules.vue?vue&type=template&id=3b4f80a5"
import script from "./PasswordRules.vue?vue&type=script&lang=ts"
export * from "./PasswordRules.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports